import { Component, Input } from '@angular/core';

import { PlaceModel } from '@app/core/models';
import {
  AnalyticsEvents,
  AnalyticsService,
} from '@app/core/services/analytics.service';
import { EventsService } from '@app/core/services/events.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input() beacon: PlaceModel;
  @Input() forHeader = false;

  constructor(
    private eventsService: EventsService,
    private analyticsService: AnalyticsService,
  ) {}

  goBack(): void {
    if (this.beacon) {
      this.analyticsService.emitEvent(AnalyticsEvents.placeBackButton, {
        placeId: this.beacon.id,
      });
      // this.eventsService.placeBackClickedSet(true);
    }
    // if (event) {
    //   event.stopPropagation();
    // }
    window.history.back();
  }
}
